<template>
  <i-modal
    v-model="modal"
    @on-visible-change="onVisibleChange"
    title="物件コピー"
    width="600"
    class="modal-property_copy"
    :closable="closable"
    :mask-closable="false"
    footer-hide
    lock-scroll
  >
    <div class="contanier">
      <template v-if="mode === 'select'">
        <div class="contents contents_select">
          <div class="property_info">
            物件管理番号：{{ property.control_no }} <br />
            物件名：{{ property.b_name }} <br />
            部屋番号：{{ property.room_no }}
          </div>
          <div class="text">を、コピーします。</div>
          <div class="btn">
            <div>
              <i-button type="primary" @click="onClickCopy(1)">物件画像を含んでコピー</i-button>
            </div>
            <div>
              <i-button type="primary" @click="onClickCopy(2)">物件画像を含まずコピー</i-button>
              <span class="btn__text">※近隣画像はコピーされます</span>
            </div>
          </div>
          <template v-if="isNewBuilding(property.m_b_type_id)">
            <div class="btn">
              <div>
                <i-button type="primary" @click="onClickCopy(3)">中古にしてコピー（画像有）</i-button>
              </div>
              <div>
                <i-button type="primary" @click="onClickCopy(4)">中古にしてコピー（画像無）</i-button>
                <span class="btn__text">※近隣画像はコピーされます</span>
              </div>
            </div>
          </template>
        </div>
      </template>

      <template v-if="mode === 'load'">
        <div class="contents contents_load">
          <div class="text">
            物件をコピーしています。しばらくお待ちください。
          </div>
          <div class="loading">
            <i-spin size="large" fix />
          </div>
        </div>
      </template>

      <template v-if="mode === 'complete'">
        <div class="contents contents_complete">
          <div class="text">
            物件のコピーが完了しました。
          </div>
          <div class="property_info" style="margin-bottom: 32px;">
            物件管理番号：{{ copyProperty.control_no }} <br />
            物件名：{{ copyProperty.b_name }} <br />
            部屋番号：{{ copyProperty.room_no }}
          </div>
          <div class="btn">
            <div>
              <i-button type="primary" @click="onClickList">閉じて一覧に戻る</i-button>
            </div>
            <div>
              <i-button type="primary" @click="onClickOpen">コピーした物件を開く</i-button>
            </div>
          </div>
        </div>
      </template>

      <template v-if="mode === 'error'">
        <div class="contents contents_error">
          <div class="text">
            物件のコピーに失敗しました。
          </div>
        </div>
      </template>
    </div>
  </i-modal>
</template>

<script>
import { Modal, Button, Spin } from 'view-design'
import BukkenRepository from '@/repositories/bukkenRepository'
import { isResidence, isInvestment, isNewBuilding } from '@/util/m_b_type.js'
const EDITOR_URL = `${process.env.VUE_APP_EDITOR_DOMAIN}/edit`
const COPY_CONFIRM_TIME = 5000
export default {
  components: {
    'i-modal': Modal,
    'i-button': Button,
    'i-spin': Spin,
  },
  data() {
    return {
      mode: 'select', // select, load, complete, error
      copyProperty: {
        b_name: '',
        b_regular_id: null,
        control_no: null,
        room_no: null,
      },
    }
  },
  computed: {
    modal: {
      get() {
        return this.$store.getters['ModalPropertyCopy/getModal']
      },
      set(val) {
        this.$store.commit('ModalPropertyCopy/setModal', val)
      },
    },
    property() {
      return this.$store.getters['ModalPropertyCopy/getProperty']
    },
    closable() {
      return this.mode === 'load' ? false : true
    },
  },
  methods: {
    // モーダル 表示/非表示時の処理
    async onVisibleChange(isOpen) {
      if (isOpen) {
        // 表示処理
      } else {
        setTimeout(this.resetParam, 300)
      }
    },
    // 物件コピー 実谷
    async onClickCopy(copyType) {
      this.mode = 'load'
      // 物件コピー処理
      const copyId = await BukkenRepository.copy(this.property.id, copyType)
        .then(res => {
          if (res.result) {
            return res.data
          } else {
            return null
          }
        })
        .catch(e => {
          console.log(e)
          return null
        })
        .finally(() => {})

      if (!copyId) {
        this.mode = 'error'
        return
      }

      const copyProperty = await this.copyConfirm(copyId)
      if (!copyProperty) {
        this.mode = 'error'
        return
      }

      this.copyProperty = copyProperty
      this.mode = 'complete'
    },
    // 新築判定
    isNewBuilding(mBTypeId) {
      return isNewBuilding(mBTypeId)
    },
    // 閉じて一覧に戻るボタン クリック処理
    onClickList() {
      this.$emit('search')
      this.modal = false
    },
    // コピーした物件を開くボタン クリック処理
    onClickOpen() {
      let type = ''
      if (isResidence(this.property.m_b_type_id)) type = 'residence'
      if (isInvestment(this.property.m_b_type_id)) type = 'investment'
      window.open(`${EDITOR_URL}/${type}/${this.copyProperty.b_regular_id}/regulars`, '_blank')
      this.$emit('search')
      this.modal = false
    },
    // モーダル キャンセル時の処理
    onClickCancel() {
      this.modal = false
    },
    // 物件コピー生成状況を確認する
    async copyConfirm(copyId) {
      return await new Promise(resolve => {
        const interval = setInterval(() => {
          BukkenRepository.copyConfirm(copyId)
            .then(res => {
              if (res.result) {
                if (res.data.status === 'finished') {
                  resolve(res.data)
                  clearInterval(interval)
                } else if (res.data.status === 'Processing') {
                  // 継続
                }
              } else {
                resolve(null)
                clearInterval(interval)
              }
            })
            .catch(e => {
              console.log(e)
              resolve(null)
              clearInterval(interval)
            })
            .finally(() => {})
        }, COPY_CONFIRM_TIME)
      })
    },
    // パラメータをリセットする
    resetParam() {
      // iviewモーダルが起動された際、bodyに付与されるstyle`overflow:hidden`が残るケースがあるので、
      // 動的にvisibleを付与する
      const bodyElement = document.getElementById('top')
      bodyElement.style.overflow = 'visible'

      this.mode = 'select'
      this.copyProperty = {
        b_name: '',
        b_regular_id: null,
        control_no: null,
        room_no: null,
      }
      this.$store.dispatch('ModalPropertyCopy/reset')
    },
  },
}
</script>

<style lang="scss" scoped>
.modal-property_copy {
  .contents {
    text-align: center;
    .property_info {
      width: 64%;
      margin: 0 auto 16px;
      font-size: 14px;
      font-weight: bold;
    }
    .btn {
      display: flex;
      justify-content: space-around;
      text-align: center;
      margin-bottom: 16px;
      &__text {
        display: block;
        padding-top: 4px;
        font-size: 11px;
      }
    }
    &_select {
      .text {
        margin-bottom: 24px;
      }
    }
    &_load {
      .text {
        padding: 24px;
        font-size: 14px;
        font-weight: bold;
      }
      .loading {
        position: relative;
        width: 100%;
        height: 80px;
      }
    }
    &_complete {
      .text {
        padding: 24px;
        font-size: 14px;
        font-weight: bold;
        text-align: center;
      }
    }
    &_error {
      .text {
        padding: 24px;
        font-size: 14px;
        font-weight: bold;
        text-align: center;
      }
    }
  }
}
</style>
